export const StoredCardsPageStyles = {
    container:
        'mx-auto sm:px-2 md:px-4 lg:px-6 pb-1 sm:pb-0 sm:pt-2 md:pt-4 lg:pt-6 relative ml-3 sm:ml-0 flex-1 relative h-full flex flex-col w-full',
    headerContainer:
        'flex flex-col sm:flex-row justify-between ml-2 sm:ml-7 sm:items-center items-start mb-4 sm:mb-6 gap-4 sm:gap-0 px-4 sm:items-start sm:mr-0',
    navContainer: 'flex items-start',
    titleContainer: 'flex flex-col items-start mr-0.5',
    homeButton: 'text-xs sm:text-sm text-[#5B03AD] cursor-pointer',
    buttonContainer: {
        large: 'hidden sm:block mr-4 md:mr-2 lg:mr-2',
        mobile: 'flex-shrink-0 px-6 pr-2 py-0 mt-2 z-10 block sm:hidden'
    },
    loaderContainer: 'flex items-center justify-center min-h-screen w-full',
    contentContainer:
        'mx-auto w-full relative h-full min-h-0 flex flex-col sm:px-4',
    searchContainer: 'flex-shrink-0 px-4 py-0',
    listContainer: 'flex-1 pl-4 py-0'
};